import { DateTime } from 'luxon';

export function formatDate(birthday: string | Date, withDay: boolean = true): string {
  const format: string = withDay ? 'yyyy-LL-dd' : 'yyyy-LL';
  if (typeof birthday === 'string') {
    return DateTime.fromISO(birthday).toFormat(format);
  }
  return DateTime.fromJSDate(birthday).toFormat(format);
}
